 document.addEventListener("DOMContentLoaded", function () {
    fetch("https://api.ipapi.com/api/check?access_key=53e4f03f4bbf4d30df280f804e44ebc2")
        .then(response => response.json())
        .then(data => {
            let userCountry = data.country_code; // "AU" for Australia
          //alert(userCountry);
            if (userCountry === "AU") { // Show popup only for AU visitors
                showCountryPopup();
            }
        })
        .catch(error => console.error("Error fetching IP info:", error));
});

function showCountryPopup() {
   const popup = document.querySelector('.au-popup-section');
  if (popup) {
    popup.style.display = 'block'; // or 'flex' if it's flex-based
  }
}

 document.querySelector('.au_popup_close').addEventListener('click', function () {
    const popup = document.querySelector('.au-popup-section');
    if (popup) {
      popup.style.display = 'none';
    }
  });